import React, { useRef, useEffect } from "react";
import { compose, withProps } from "recompose";
import {
    withScriptjs,
    withGoogleMap,
    KmlLayer,
    GoogleMap,
} from "react-google-maps";
import CustomMarker from "./CustomMarker";

export default compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyB2YuXwnmHxhLxdw_gCZJ4yZ03jSksoDHM",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `700px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(({ markers, onMarkerClick, kml, hideLabel, preDefinedZoom }) => {
    let mapRef = useRef(null);
    let kmlRef = useRef(null);

    const fitBounds = () => {
        if (!preDefinedZoom) {
            const bounds = new window.google.maps.LatLngBounds();
            markers.map(item => {
                bounds.extend(item.position);
            });
            mapRef.fitBounds(bounds);
        }
    };

    if (kml) {
        useEffect(() => {
            kmlRef.getDefaultViewport();
        }, [kml]);
    } else {
        useEffect(() => {
            fitBounds();
        }, [markers]);
    }

    const center = markers.length ? markers[0].position : {
        lat: 4.0204989,
        lng: -118.4117325
    };
    return (
        <GoogleMap
            ref={(c) => mapRef = c}
            defaultZoom={19}
            defaultCenter={center}
            options={{ styles }}
        >
            {!!kml ? (
                <KmlLayer
                    ref={(c) => kmlRef = c}
                    url={kml}
                    // url="https://controllerdata.lacity.org/api/geospatial/3mvs-psab?method=export&format=KML"
                />
            ) : (
                markers.map(marker => (
                    <CustomMarker
                        key={'marker-' + marker.id}
                        marker={marker}
                        onClick={onMarkerClick}
                        hideLabel={hideLabel}
                    />
                ))
            )}
        </GoogleMap>
    )
});

const styles = [
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "-100"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 65
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": "50"
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "-100"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "lightness": "30"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "lightness": "40"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#ffff00"
            },
            {
                "lightness": -25
            },
            {
                "saturation": -97
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "lightness": -25
            },
            {
                "saturation": -100
            }
        ]
    },
];
